import { render, staticRenderFns } from "./MoneyPreview.vue?vue&type=template&id=a55e5e16&"
import script from "./MoneyPreview.vue?vue&type=script&lang=ts&"
export * from "./MoneyPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports